import React from 'react';

export default function Header() {
    return (
        <div className="header container-fluid">
            <h1 className="title"><a href="https://github.com/Souto751" className="link">Souto751</a></h1>
        </div>
    )
}
